import styled from 'styled-components'
import { SvgScaniaWordmark } from '../../components/SvgImports'
import { TextId, useTextsV2 } from '../../utils/useTexts'
import { SuperCampaignData } from './SuperCampaignData'
import { SuperCampaignFooter } from './SuperCampaignFooter'

interface PortraitFooterComponentProps {
  $displayAtScreenMaxWidth: number
  $displayAtScreenMaxHeight?: number
}

const PortraitFooterRoot = styled.div<PortraitFooterComponentProps>`
  display: none;
  height: var(--footer-height-mobile);
  min-height: var(--footer-height-mobile);
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: var(--tds-blue-800);
  padding: 24px;

  @media screen and (max-width: ${(props) =>
      props.$displayAtScreenMaxWidth}px) {
    display: flex;
  }

  @media screen and (max-height: ${(props) =>
      props.$displayAtScreenMaxHeight}px) {
    display: flex;
  }
`

const Divider = styled.div`
  border-top-color: var(--tds-blue-600);
  border-top-style: solid;
  border-top-width: thin;
  margin-bottom: 24px;
  width: 100%;
`

const LogotypeWrapper = styled.div`
  align-items: flex-end;
  align-self: flex-end;
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  justify-self: flex-end;

  svg {
    height: 22px;
    width: auto;
    path {
      fill: var(--tds-white);
    }
  }
`

const CopyTextline = styled.p`
  margin: 0;
`

const SuperCampaignFooterWrapper = styled.div`
  width: 100%;
  margin-bottom: 24px;
`

interface PortraitFooterProps {
  displayAtScreenMaxWidth: number
  displayAtScreenMaxHeight?: number
  superCampaignData?: SuperCampaignData
}

export function PortraitFooter({
  displayAtScreenMaxWidth,
  displayAtScreenMaxHeight,
  superCampaignData,
}: PortraitFooterProps): JSX.Element {
  const t2 = useTextsV2()
  const copyTextLines = t2(TextId.SCANIA_COPYRIGHT).trim().split('\n')

  return (
    <PortraitFooterRoot
      data-name="Footer"
      $displayAtScreenMaxWidth={displayAtScreenMaxWidth}
      $displayAtScreenMaxHeight={displayAtScreenMaxHeight}
    >
      {superCampaignData && (
        <SuperCampaignFooterWrapper>
          <SuperCampaignFooter {...superCampaignData} />
        </SuperCampaignFooterWrapper>
      )}
      <Divider />
      <span style={{ color: 'var(--tds-grey-600)' }} className="tds-detail-05">
        {copyTextLines.map((line, i) => (
          <CopyTextline key={'copy-text-line-' + i + line}>{line}</CopyTextline>
        ))}
      </span>
      <LogotypeWrapper>
        <SvgScaniaWordmark />
      </LogotypeWrapper>
    </PortraitFooterRoot>
  )
}
